








































































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { obrigatorio } from '@/shareds/regras-de-form'
import { TipoDeOperacao } from '@/models/Recurso'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import { AcaoDeCashback } from '@/models/AcaoDeCashback'
import SeletorDeGruposEconomicos from "@/components/loja/SeletorDeGruposEconomicos.vue"
import { SaveCashbackUseCase } from '@/usecases'
import DatePicker from '@/components/ui/DatePicker.vue'
import moment from "moment"

@Component({
	components: {
		SeletorDeLojasDoUsuario,
		SeletorDeGruposEconomicos,
		DatePicker,
	},
})

export default class DialogoDeEdicaoDeAcaoDeCashback extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeNomeAcao!: HTMLInputElement

	acaoDeCashback: AcaoDeCashback | null = null
	obrigatorio = obrigatorio
	mostra = false
	criandoNovaAcao = false
	salvando = false
	nomeTransbordou = false
	descricaoTransbordou = false
	saveCashbackUseCase = new SaveCashbackUseCase()

	exemploMensagem = 'Ex.: Olá {{cliente}}, seu cashback expira em {{dataFim}}. Aproveite!'

	variaveisDaMensagem = [
		{ rotulo: 'Nome do cliente', token: '{{cliente}}' },
		{ rotulo: 'Nome fantasia da loja', token: '{{fantasia}}' },
		{ rotulo: 'Data de expiração', token: '{{dataFim}}' },
		{ rotulo: 'Último vendedor', token: '{{vendedor}}' },
		{ rotulo: 'Razão social da loja', token: '{{razaoSocial}}' },
		{ rotulo: 'Valor total', token: '{{valorTotal}}' },
		{ rotulo: 'Quebra de linha', token: '\n' },
	]

	mostrar(acaoDeCashback: AcaoDeCashback | null, criandoNovaAcao: boolean ) {
		this.acaoDeCashback = JSON.parse(JSON.stringify(acaoDeCashback))

		if (this.acaoDeCashback) {
			if (this.acaoDeCashback.dataInicio) {
				this.acaoDeCashback.dataInicio = moment(this.acaoDeCashback.dataInicio).subtract(3, 'hours').format('YYYY-MM-DD')
			}
			if (this.acaoDeCashback.dataFim) {
				this.acaoDeCashback.dataFim = moment(this.acaoDeCashback.dataFim).subtract(3, 'hours').format('YYYY-MM-DD')
			}
		}

		this.mostra = true
		this.criandoNovaAcao = criandoNovaAcao

		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeNomeAcao.focus()
		})
	}

	esconder() {
		this.acaoDeCashback = null
		this.mostra = false
	}

	inserirVariavel(token: string) {
		if (!this.acaoDeCashback) return
		this.$set(this.acaoDeCashback, 'mensagemAcao', (this.acaoDeCashback.mensagemAcao || '') + token)
	}

	verificarTransbordo(ref: string): boolean {
		const componente = this.$refs[ref] as Vue | undefined
		const input = componente?.$el.querySelector('input') as HTMLInputElement | null
		return !!input && input.scrollWidth > input.clientWidth
	}

	get podeAlterarAcao() {
		return this.podeRealizarOperacao('alterar')
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'acoes-de-manutencao-de-cashback'))
	}

	gerarDataHora(data?: string | null, hora?: string | null): string {
		return moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm').toISOString(true)
	}

	async salvar(){
		if (!this.acaoDeCashback) return
		if (!this.form.validate()) return
		try {
			if(!this.acaoDeCashback.grupoEconomico){
				AlertModule.setError('Obrigatório informar grupo econômico')
			}
			this.salvando = true
			const payload: AcaoDeCashback = {
				...this.acaoDeCashback,
				dataInicio: moment(this.gerarDataHora(this.acaoDeCashback.dataInicio, '00:00')).add(3, 'hours').toISOString(true),
				dataFim: moment(this.gerarDataHora(this.acaoDeCashback.dataFim, '23:59')).add(3, 'hours').toISOString(true),
			}

			const acaoSalva = !payload.id
				? await this.saveCashbackUseCase.criarAcaoDeCashback(payload)
				: await this.saveCashbackUseCase.atualizarAcaoDeCashback(payload)

			this.$emit('confirmado', acaoSalva)
			this.mostra = false
			AlertModule.setSuccess('Ação de Cashback salva com sucesso')
		}catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.$emit('sucesso')
		}
	}

}
